import EducationCard from "./EducationCard";

export default function Education({ educationList }) {
  return (
    <section
      id="education"
      className="relative bg-[#081712] text-[#F1E9D8] px-6 md:px-10 py-32 grain"
    >
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[26rem] h-[26rem] rounded-full bg-[#26502F] opacity-30 blur-[130px]" />

      <div className="max-w-2xl mx-auto relative">
        <div className="flex items-center justify-center gap-4 mb-16">
          <span className="text-sm text-[#D4AF6A]">02</span>
          <span className="w-10 h-px bg-[#D4AF6A]/40" />
          <h2 className="font-display text-4xl md:text-5xl font-light">
            Education
          </h2>
          <span className="w-10 h-px bg-[#D4AF6A]/40" />
          <span className="text-sm text-[#D4AF6A]">02</span>
        </div>

        <div>
          {educationList.map((education, index) => (
            <EducationCard
              key={index}
              {...education}
              isLast={index === educationList.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
